// extracted by mini-css-extract-plugin
export default {"variables":"\"variables.css\"","mobile-threshold-width":"760px","container":"PalletAmountListItem_container__4Or36","isFree":"PalletAmountListItem_isFree__2ycCg"};